import { createEntityAdapter, PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store';

const notificationsAdapter = createEntityAdapter({});

const initialState = notificationsAdapter.upsertMany(notificationsAdapter.getInitialState(), []);

export const {
	selectAll: selectNotifications,
	selectById: selectNotificationsById
} = notificationsAdapter.getSelectors<RootState>(state => state.notificationPanel.data);

const dataSlice = createSlice({
	name: 'notificationPanel/data',
	initialState,
	reducers: {
		dismissItem: (state, action: PayloadAction<any>) => notificationsAdapter.removeOne(state, action.payload),
		dismissAll: (state) => notificationsAdapter.removeAll(state),
		addNotification: (state, action: PayloadAction<any>) => notificationsAdapter.addOne(state, action.payload)
	}
});

export const { dismissItem, dismissAll, addNotification } = dataSlice.actions;

export default dataSlice.reducer;
